<div
  class="row table-div"
  *ngIf="
    (processIncluded.isMaterial && impactItems?.materialDataSourceList?.length > 0) ||
    (processIncluded.isConversion && impactItems?.conversionProcessDataSourceList?.length > 0)
  "
>
  <div class="tableHeadingForLifecycleStage">Scenario name: {{ impactItems?.scenarioName }}</div>
</div>
<div *ngIf="isCheckISO" class="row table-div">
  <div class="indicatorName">
    {{ reportResource.lblBackgroundData }} {{ impactItems?.scenarioName }}
  </div>
</div>

<div
  class="row table-div"
  *ngIf="processIncluded.isMaterial && impactItems?.materialDataSourceList?.length > 0"
>
  <div class="table-content">
    <div class="tableHeading">
      <div>{{ reportResource.lblMaterials }}</div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <td>{{ reportResource.lblComponentName }}</td>
          <td>{{ reportResource.lblMaterial }}</td>
          <td>{{ reportResource.lblSource }}</td>
          <td>{{ reportResource.lblTimePeriod }}</td>
          <td>{{ reportResource.lblGeoGraphy }}</td>
          <td>{{ reportResource.lblProcess }}</td>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let material of impactItems?.materialDataSourceList">
          <td>{{ material.datasourceName }}</td>
          <td>{{ material.materialName }}</td>
          <td>{{ material.source }}</td>
          <td>{{ material.timePeriod }}</td>
          <td>{{ material.geoGraphy }}</td>
          <td>{{ material.process }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="processIncluded.isConversion && impactItems?.conversionProcessDataSourceList?.length > 0"
>
  <div class="table-content">
    <div class="tableHeading">
      <div>{{ reportResource.lblConversionProcess }}</div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <td>{{ reportResource.lblComponentName }}</td>
          <td>{{ reportResource.lblConversion }}</td>
          <td>{{ reportResource.lblSource }}</td>
          <td>{{ reportResource.lblTimePeriod }}</td>
          <td>{{ reportResource.lblGeoGraphy }}</td>
          <td>{{ reportResource.lblProcess }}</td>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let conversion of impactItems?.conversionProcessDataSourceList">
          <td>{{ conversion.datasourceName }}</td>
          <td>{{ conversion.conversionName }}</td>
          <td>{{ conversion.source }}</td>
          <td>{{ conversion.timePeriod }}</td>
          <td>{{ conversion.geoGraphy }}</td>
          <td>{{ conversion.process }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="isCheckISO && !processIncluded.isConversion && !processIncluded.isMaterial">
  <p>{{ reportResource.lblNoData }}</p>
</div>
